import i18n from 'config/i18n';
import i18next from 'i18next';
import { path } from 'ramda';

import { showErrorSnackbar } from './Snackbar';

export const getTranslationKeyIfExists = (
  translationKey: string
): string | null => {
  if (translationKey && i18next.exists(translationKey)) {
    return translationKey;
  } else {
    return null;
  }
};

/**
 * The text for a translation key, or null when the key is missing or names a
 * group of translations rather than one (i18n runs with `returnObjects`, so
 * `exists` alone would accept `backend_error.scheduling`).
 */
const translateIfExists = (translationKey: string): string | null => {
  if (!getTranslationKeyIfExists(translationKey)) return null;
  const text = i18n.t(translationKey);
  return typeof text === 'string' ? text : null;
};

/**
 * Shows the translated message for a failed request whose backend message code
 * has a translation; any other failure gets the generic error snackbar. Codes
 * from `common/error_codes` live under `backend_error.<code>`; a message that
 * is itself a full translation key is accepted as well.
 */
const showError = (error: unknown) => {
  const code = path(['response', 'data', 'error', 'message'], error);
  const text =
    typeof code === 'string' && code
      ? translateIfExists(`backend_error.${code}`) ?? translateIfExists(code)
      : null;
  showErrorSnackbar(text ?? undefined);
};

export default showError;
